import { introConfig, introEnabled } from "./config/motion";
import { interactionConfig, messages } from "./config/ui";

// Classic scripts also work when index.html is opened directly with file://.
if (
	introEnabled &&
	!window.matchMedia(interactionConfig.reducedMotionQuery).matches
) {
	document.documentElement.classList.add("intro-active", "intro-centered");
}
// Restore the full page if a dependency never loads.
window.setTimeout(() => {
	if (window.pixelIntro?.active) window.pixelIntro.finish();
	else
		document.documentElement.classList.remove(
			"intro-active",
			"intro-centered",
		);
}, introConfig.startupTimeoutMs);
window.addEventListener(
	"error",
	function (event) {
		window.pixelIntro?.finish();
		document.documentElement.classList.remove(
			"intro-active",
			"intro-centered",
		);
		const error = document.querySelector<HTMLElement>("#error");
		if (!error) return;
		document.querySelector("#loading")?.remove();
		error.hidden = false;
		error.textContent =
			event.target instanceof HTMLScriptElement
				? messages.missingFile
				: messages.startupError +
					(event.message || messages.loadingError);
	},
	true,
);
